import {
  batchTransferStatus,
  paymentLinkStatus,
  payoutStatus,
  productStatus,
  teamMemberStatus,
  transactionStatus,
  transferStatus,
} from "../enums";
import {
  IViewBatchTransfer,
  IViewPaymentLink,
  IViewProduct,
  IViewTeamMember,
  IViewTransactionListItem,
  IViewSingleTransfer,
  StatusColors,
  IViewPayoutListItem,
  IViewVirtualAccountTransferRefund,
} from "../interfaces-and-types";
import { camelCaseToCapitalized } from "./string-utils";

export function getPaymentStatusIndicator(payment: IViewTransactionListItem) {
  const statusIndicator: { statusText: string; statusType: StatusColors } = {
    statusText: payment.status,
    statusType:
      payment.status === transactionStatus.failed
        ? "danger"
        : payment.status === transactionStatus.successful
        ? "success"
        : payment.status === transactionStatus.processing
        ? "teal"
        : payment.status === transactionStatus.abandoned
        ? "secondary"
        : payment.status === transactionStatus.partial
        ? "primary"
        : "warning",
  };

  return statusIndicator;
}

export function getProductStatusIndicator(product: IViewProduct) {
  const statusIndicator: { statusText: string; statusType: StatusColors } =
    product.status === productStatus.active
      ? { statusText: "Active", statusType: "success" }
      : product.status === productStatus.staging
      ? { statusText: "Staging", statusType: "teal" }
      : { statusText: "Deactivated", statusType: "secondary" };

  return statusIndicator;
}

export function getPaymentLinkStatusIndicator(paymentLink: IViewPaymentLink) {
  const statusIndicator: { statusText: string; statusType: StatusColors } =
    paymentLink.status === paymentLinkStatus.active
      ? { statusText: "Active", statusType: "success" }
      : { statusText: "Deactivated", statusType: "secondary" };

  return statusIndicator;
}

export function getTeamMemberStatusIndicator(teamMember: IViewTeamMember) {
  const statusIndicator: { statusText: string; statusType: StatusColors } =
    teamMember.status === teamMemberStatus.active
      ? { statusText: "Active", statusType: "success" }
      : teamMember.status === teamMemberStatus.disabled
      ? { statusText: "Disabled", statusType: "danger" }
      : { statusText: "Pending", statusType: "secondary" };

  return statusIndicator;
}

// export function getBatchTransferStatusIndicator(batch: IViewBatchTransfer) {
//   const statusIndicator: { statusText: string; statusType: StatusColors } =
//     batch.status === batchTransferStatus.allFailed ||
//     batch.status === batchTransferStatus.otpDispatchFailed
//       ? { statusText: "failed", statusType: "danger" }
//       : batch.status === batchTransferStatus.allSuccessful
//       ? { statusText: "successful", statusType: "success" }
//       : batch.status === batchTransferStatus.partialSuccessful
//       ? { statusText: "partial", statusType: "teal" }
//       : { statusText: "processing", statusType: "secondary" };

//   return statusIndicator;
// }
export function getBatchTransferStatusIndicator(batch: IViewBatchTransfer): {
  statusText: string;
  statusType: StatusColors;
} {
  const statusIndicatorColor: StatusColors =
    batch.status === batchTransferStatus.allFailed ||
    batch.status === batchTransferStatus.approvalExpired ||
    batch.status === batchTransferStatus.otpDispatchFailed
      ? "danger"
      : batch.status === batchTransferStatus.allSuccessful
      ? "success"
      : batch.status === batchTransferStatus.partialSuccessful
      ? "teal"
      : "secondary";

  return {
    statusText: camelCaseToCapitalized(batch.status),
    statusType: statusIndicatorColor,
  };
}

export function getTransferStatusIndicator(transfer: IViewSingleTransfer) {
  const statusIndicator: { statusText: string; statusType: StatusColors } = {
    statusText: transfer.status,
    statusType:
      transfer.status === transferStatus.successful
        ? "success"
        : transfer.status === transferStatus.failed ||
          transfer.status === transferStatus.reversed
        ? "danger"
        : "secondary",
  };

  return statusIndicator;
}

export function getPayoutStatusIndicator(payout: IViewPayoutListItem) {
  const statusIndicator: { statusText: string; statusType: StatusColors } = {
    statusText: payout.status, //=== "failed" ? "retrying" : payout.status,
    statusType:
      payout.status === payoutStatus.successful
        ? "success"
        : payout.status === payoutStatus.failed
        ? "danger"
        : "secondary", // payout.status === payoutStatus.processing
  };

  return statusIndicator;
}

export function getVirtualAccountTransferRefundStatusIndicator(
  virtualTransferRefund: IViewVirtualAccountTransferRefund
) {
  const statusIndicator: { statusText: string; statusType: StatusColors } = {
    statusText: virtualTransferRefund.is_refund_completed
      ? "settled"
      : "pending",
    statusType: virtualTransferRefund.is_refund_completed
      ? "success"
      : "secondary",
  };

  return statusIndicator;
}
